import {useAccount} from 'wagmi';

export const useConnectorName = () => {
  const account = useAccount();

  return account?.connector?.id;
};
